module.exports = __webpack_public_path__ + "img/u2.c8928856.svg";